module.exports = __webpack_public_path__ + "static/media/xs_pointer_dark.e2aed579.svg";